import React from 'react'
import EightRooms from '../components/EightRooms'
import Biography from '../components/Biography/Biography'

class BiographyPage extends React.Component {
  render() {
    const pageData = this.props.data.allWordpressPage.edges[0].node
    return <Biography data={pageData} />
  }
}

export default BiographyPage

export const pageQuery = graphql`
  query bioQuery {
    allWordpressPage(filter: { wordpress_id: { eq: 113 } }) {
      edges {
        node {
          content
          acf {
            bio_image {
              source_url
            }
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/biography.js